module.exports = __webpack_public_path__ + "static/7-a4a25c176011592f91402c59e3c5d3c8.jpg";